import { Link } from "react-router-dom";

export default function Forbidden() {
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-24 text-center space-y-8">
      <div className="inline-flex h-20 w-20 items-center justify-center rounded-full bg-brand-100 text-brand-600">
        <i className="fa-light fa-lock text-4xl" />
      </div>
      <div className="space-y-3">
        <p className="text-sm font-semibold text-brand-600 uppercase tracking-wider">Fejl 403</p>
        <h1 className="text-4xl font-bold font-display text-brand-950 sm:text-5xl">
          Adgang nægtet
        </h1>
        <p className="text-base text-brand-700 max-w-md mx-auto">
          Du har ikke tilladelse til at tilgå denne side. Hvis du mener, dette er en fejl, bedes du kontakte klinikken.
        </p>
      </div>
      <div className="pt-4">
        <Link
          to="/"
          className="inline-flex items-center justify-center rounded-full bg-brand-600 px-8 py-3.5 text-sm font-semibold text-white shadow-sm hover:bg-brand-700 transition-colors cursor-pointer"
        >
          Gå til forsiden
        </Link>
      </div>
    </div>
  );
}
